module.exports = __webpack_public_path__ + "img/categorie-cave-famille-boutrais.ef9ec8ed.jpg";